import { FC } from 'react'

import { Modal } from '@inno-ui/modal'
import { useTranslation } from 'react-i18next'

import { ArtifactFrame } from '../../ArtifactFrame'
import styles from '../ReviewQueue.module.scss'
import { REVIEW_MODAL_CHROME } from './CardShell'

interface RevealModalProps {
  publicId: string
  title: string
  // controlled open state — parent decides when to show
  isOpen: boolean
  onClose: () => void
}

// Reveals the widget so a reviewer can verify the user-facing experience
// before approving. Shows both surfaces the widget ships with — the mini tile
// (how it looks pinned to the desktop) and the full view (opened) — separated
// and labelled, so "is this safe to pin?" is answered for both sizes.
export const RevealModal: FC<RevealModalProps> = ({
  publicId,
  title,
  isOpen,
  onClose
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'widgets.aiAgent' })

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      {...REVIEW_MODAL_CHROME}
      maxWidth='92vw'
      maxHeight='92vh'
      layers={[
        {
          title: t('preview_modal_title', { title }),
          bodyPaddings: false,
          body: (
            <div className={styles.previewStack}>
              <section className={styles.previewSection}>
                <span className={styles.previewLabel}>
                  {t('preview_mini_label')}
                </span>
                <div className={styles.previewMini}>
                  <ArtifactFrame
                    publicId={publicId}
                    view='mini'
                    isInFullView={false}
                    noOverlay
                    hideBar
                  />
                </div>
              </section>

              <section className={styles.previewSection}>
                <span className={styles.previewLabel}>
                  {t('preview_full_label')}
                </span>
                <div className={styles.previewFull}>
                  <ArtifactFrame
                    publicId={publicId}
                    view='full'
                    isInFullView
                    noOverlay
                    hideBar
                  />
                </div>
              </section>
            </div>
          )
        }
      ]}
    />
  )
}
